/* Stroomkaart - translations: info pages (over, contact, inloggen)
   ============================================ */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const nl = {
  /* ----- Over & Contact ----- */
  over: {
    title: 'Over Stroomkaart - Stroomkaart',
    eyebrow: 'Over Stroomkaart',
    h1: 'Eén marktplaats voor alle beschikbare stroomvoorzieningen.',
    lede: 'Stroomkaart is een initiatief van NRG Group om bestaande stroomcapaciteit zichtbaar en benutbaar te maken. In een tijd waarin nieuwe netaansluitingen jaren wachttijd hebben, ligt de oplossing vaak in wat er al is - mits je het kunt vinden.',
    sec1: {
      eyebrow: 'Contact',
      title: 'Vragen, ideeën of samenwerken?',
      sub: 'We horen graag van bouwers, overheidsorganisaties en netbeheerders. Ook als je nog niet zeker weet of Stroomkaart bij jullie past.'
    },
    why_title:  'Waarom Stroomkaart bestaat',
    why_p1:     'Tot 2023 werkte het zo: een aannemer kreeg een opdracht, vroeg een tijdelijke netaansluiting aan, en wachtte. Maanden. Soms langer dan de bouwtijd zelf. Tegelijk stonden in dezelfde gemeente bestaande, betaalde stroompunten ongebruikt op bijvoorbeeld evenemententerreinen en bedrijfslocaties.',
    why_p2:     'NRG Group werkt al jaren in energieadvies en levering van energiemonitoring. Onze adviseurs zagen het probleem aan beide kanten: bouwers die niet konden starten, gemeenten met capaciteit die niemand kende. Stroomkaart is gebouwd om die twee werelden te verbinden.',
    what_title: 'Wat we doen',
    what_p1:    'Stroomkaart is een marktplaats. Geen netbeheerder, geen energieleverancier - we doen één ding goed: vraag en aanbod van bestaande stroompunten zichtbaar maken en het traject eromheen zo soepel mogelijk laten verlopen.',
    what_li1:   'Voor gebruikers: één kaart, één aanvraagprocedure, één aanspreekpunt',
    what_li2:   'Voor gemeenten en eigenaren: tooling om punten zichtbaar te maken, voorwaarden te stellen en gebruik te monitoren',
    what_li3:   'Voor netbeheerders: minder onnodige nieuwe aansluitaanvragen, beter benutte capaciteit',
    init_title: 'Initiatief van NRG Group',
    init_p1:    'Stroomkaart is onderdeel van <a href="https://www.nrggroup.nl" target="_blank" rel="noopener">NRG Group</a>, een Nederlandse organisatie die werkt aan slimme energieoplossingen rondom energiemonitoring en -verrekening.',
    init_p2:    '',
    contact: {
      direct:   'Direct contact',
      general:  'Algemeen',
      address:  'Adres',
    },
    form: {
      name:           'Naam',
      org:            'Organisatie',
      email:          'E-mailadres',
      phone:          'Telefoon (optioneel)',
      topic:          'Onderwerp',
      choose:         'Maak een keuze…',
      opt_existing:   'Vraag over een lopende aanvraag',
      opt_new:        'Een nieuw project',
      opt_gov:        'Samenwerking als overheidsorganisatie',
      opt_grid:       'Samenwerking als netbeheerder',
      opt_press:      'Pers- of mediavraag',
      opt_register:   'Aansluiting aanmelden',
      opt_other:      'Anders',
      msg:            'Je bericht',
      msg_ph:         'Vertel ons waar we mee kunnen helpen…',
      submit:         'Verstuur bericht →',
    },
  },
  contact: {
    title: 'Contact - Stroomkaart',
    eyebrow: 'Contact',
    h1: 'Neem contact met ons op.',
    lede: 'Vragen over Stroomkaart, een specifiek stroompunt, of de aanmeld-procedure? We helpen je graag verder.',
    info: {
      title:       'Direct contact',
      general:     'Algemeen',
      address:     'Adres',
      hours:       'Openings­tijden',
      hours_value: 'Maandag t/m vrijdag<br/>08:00 – 17:30 uur',
    },
    form: {
      name:                  'Naam',
      organisation:          'Organisatie',
      email:                 'E-mailadres',
      phone:                 'Telefoon (optioneel)',
      topic:                 'Onderwerp',
      topic_placeholder:     'Maak een keuze…',
      topic_existing_request:'Vraag over een lopende aanvraag',
      topic_new_project:     'Een nieuw project',
      topic_charging_card:   'Bouwlaadpas aanvragen',
      topic_municipality:    'Samenwerking als gemeente',
      topic_grid_operator:   'Samenwerking als netbeheerder',
      topic_press:           'Pers- of mediavraag',
      topic_other:           'Anders',
      message:               'Je bericht',
      message_placeholder:   'Vertel ons waar we mee kunnen helpen…',
      submit:                'Verstuur bericht →',
      success:               'Bedankt - je bericht is verstuurd. We nemen zo snel mogelijk contact op.',
      err_validation:        'Vul alle verplichte velden in (bericht moet minimaal 10 tekens zijn).',
      err_rate_limited:      'Te veel berichten verstuurd. Wacht een paar minuten en probeer het opnieuw.',
      err_submit:            'Bericht versturen mislukt. Probeer het later opnieuw.',
    },
    // Legacy keys kept so any older HTML still renders during the rollout.
    label_name:    'Naam',
    label_email:   'E-mailadres',
    label_subject: 'Onderwerp',
    label_message: 'Bericht',
    btn_send:      'Verstuur bericht',
  },
  /* ----- Inloggen ----- */
  inloggen: {
    title: 'Inloggen - Stroomkaart',
    aside: {
      eyebrow:    'Beheerportaal voor eigenaren',
      title:      'Beheer binnenkomende aanvragen op uw stroompunten.',
      lede:       'In het Stroomkaart-beheerportaal beheert u aanvragen voor het gebruik van uw aangemelde stroompunten - beschikbaar voor elke eigenaar die zijn aansluitingen wil beheren.',
      feature_1:  'Aanvragen op uw stroompunten inzien en goedkeuren of afwijzen',
      feature_2:  'Per aanvraag de aanvrager, locatie en gewenste periode beoordelen',
      feature_3:  'Status van openstaande, lopende en afgeronde aanvragen volgen',
      feature_4:  'Communicatie met aanvragers vanuit één centraal overzicht',
      requester_box:  '<strong style="color: var(--sk-blue-300);">Bent u aanvrager?</strong> Aanvragers hebben geen account nodig. <a href="map.html" style="color: var(--sk-blue-300); text-decoration: underline;">Open de kaart</a> of <a href="request.html" style="color: var(--sk-blue-300); text-decoration: underline;">doe direct een aanvraag</a>. Status en updates ontvangt u per e-mail.',
      signup_intro:   'Nog geen toegang? <a href="#" id="show-signup">Meld uw stroompunten aan</a> en wij richten accounts voor uw beheerportaal in. Open voor elke eigenaar - gemeenten, netbeheerders, vastgoedbeheerders en bedrijven.',
    },
    form: {
      title:    'Inloggen',
      sub:      'Toegang voor eigenaren - voor het beheren van aanvragen.',
      email:    'E-mailadres',
      password: 'Wachtwoord',
      remember: 'Onthoud mij',
      forgot:   'Wachtwoord vergeten?',
      submit:   'Inloggen →',
    },
    signup: {
      title:    'Stroompunten aanmelden',
      sub:      'Vul uw gegevens in - we nemen binnen twee werkdagen contact op.',
      org:      'Organisatie / Gemeente',
      message:  'Bericht (optioneel)',
      submit:   'Aanvragen →',
      success:  'Bedankt - we nemen binnen twee werkdagen contact met u op.',
      err_duplicate: 'Er ligt al een open aanvraag met deze gegevens. We nemen binnenkort contact op.',
      err_submit:    'Aanvraag versturen mislukt. Probeer het later opnieuw.',
    },
    back_to_login: '← Terug naar inloggen',
    divider_or:    'of',
    forgot: {
      title:        'Wachtwoord resetten',
      sub:          'Vul uw e-mailadres in. We sturen u een code waarmee u een nieuw wachtwoord kunt instellen.',
      send_code:    'Stuur code →',
      code_label:   'Code uit e-mail',
      new_password: 'Nieuw wachtwoord',
      confirm:      'Wachtwoord resetten →',
      code_sent:    'Controleer uw inbox - we hebben een code gestuurd.',
      success:      'Wachtwoord aangepast. U kunt nu inloggen.',
    },
    newpwd: {
      title:            'Nieuw wachtwoord instellen',
      sub:              'Uw account is aangemaakt met een tijdelijk wachtwoord. Kies nu een eigen wachtwoord.',
      new_password:     'Nieuw wachtwoord',
      confirm_password: 'Bevestig wachtwoord',
      submit:           'Wachtwoord opslaan →',
      mismatch:         'De wachtwoorden komen niet overeen.',
    },
    signedup_success: 'Account aangemaakt. U kunt hieronder inloggen.',
    errors: {
      not_admin:           'Uw account heeft geen beheerdersrol. Log in met een beheerdersaccount.',
      invalid_credentials: 'E-mailadres of wachtwoord onjuist.',
      not_confirmed:       'Account is nog niet bevestigd. Controleer uw e-mail voor de bevestigingscode.',
      reset_required:      'Voor uw account is een wachtwoordreset vereist. We hebben de e-mail alvast ingevuld - vraag een code aan om verder te gaan.',
      weak_password:       'Wachtwoord voldoet niet aan de eisen (min. 8 tekens, hoofdletter, cijfer, symbool).',
      rate_limited:        'Te veel pogingen. Wacht een paar minuten en probeer het opnieuw.',
      bad_code:            'Ongeldige code. Controleer uw e-mail en probeer het opnieuw.',
      expired_code:        'Code verlopen. Vraag een nieuwe code aan.',
      network:             'Geen verbinding met de server. Controleer uw internetverbinding.',
      empty_fields:        'Vul alle verplichte velden in.',
      generic:             'Er ging iets mis. Probeer het opnieuw.',
    },
  },
};

export const en = {
  over: {
    title: 'About NRGmaps - Stroomkaart',
    eyebrow: 'About NRGmaps',
    h1: 'One marketplace for all available power supplies.',
    lede: 'NRGmaps is an initiative of NRG Group to make existing power capacity visible and usable. At a time when new grid connections become more expensive and congestion is raising, the solution often lies in what is already there - if you can find it.',
    sec1: {
      eyebrow: 'Contact',
      title: 'Questions, ideas or collaboration?',
      sub: 'We hear from contractors, government organisations and grid operators. Even if you are not yet sure whether Stroomkaart fits your situation.'
    },
    why_title:  'Why NRGmaps exists',
    why_p1:     'Until 2023, this is how it worked: a contractor got a job, requested a temporary grid connection, and waited. Meanwhile, in the same municipality, existing paid-for power connections sat unused at for example event areas and business parks.',
    why_p2:     'NRG Group has worked in energy advice and energy monitoring for years. Our advisors saw the problem from both sides: builders who could not start, municipalities with capacity nobody knew about. NRGmaps was built to connect those two worlds.',
    what_title: 'What we do',
    what_p1:    'NRGmaps is a marketplace. Not a grid operator, not an energy supplier - we do one thing well: make existing power points findable and keep the process around them as smooth as possible.',
    what_li1:   'For users: one map, one request procedure, one point of contact',
    what_li2:   'For municipalities and owners: tooling to make points visible, set conditions and monitor usage',
    what_li3:   'For grid operators: fewer unnecessary new connection requests, better-utilised capacity',
    init_title: 'An initiative of NRG Group',
    init_p1:    'NRGmaps is part of <a href="https://www.nrggroup.nl" target="_blank" rel="noopener">NRG Group</a>, a Dutch organisation providing solutions for energymonitoring and settlement.',
    init_p2:    '',
    contact: {
      direct:   'Direct contact',
      general:  'General',
      address:  'Address',
    },
    form: {
      name:           'Name',
      org:            'Organisation',
      email:          'Email address',
      phone:          'Phone (optional)',
      topic:          'Subject',
      choose:         'Make a choice…',
      opt_existing:   'Question about an ongoing request',
      opt_new:        'A new project',
      opt_gov:        'Partnership as a government organisation',
      opt_grid:       'Partnership as a grid operator',
      opt_press:      'Press or media inquiry',
      opt_register:   'Register a connection',
      opt_other:      'Other',
      msg:            'Your message',
      msg_ph:         'Tell us how we can help…',
      submit:         'Send message →',
    },
  },
  contact: {
    title: 'Contact - Stroomkaart',
    eyebrow: 'Contact',
    h1: "Get in touch.",
    lede: 'Questions about Stroomkaart, a specific power point, or the registration procedure? We are happy to help.',
    info: {
      title:       'Direct contact',
      general:     'General',
      address:     'Address',
      hours:       'Opening hours',
      hours_value: 'Monday to Friday<br/>08:00 – 17:30',
    },
    form: {
      name:                  'Name',
      organisation:          'Organisation',
      email:                 'Email',
      phone:                 'Phone (optional)',
      topic:                 'Subject',
      topic_placeholder:     'Make a selection…',
      topic_existing_request:'Question about an existing request',
      topic_new_project:     'A new project',
      topic_charging_card:   'Request a charging card',
      topic_municipality:    'Partnership as a municipality',
      topic_grid_operator:   'Partnership as a grid operator',
      topic_press:           'Press or media enquiry',
      topic_other:           'Something else',
      message:               'Your message',
      message_placeholder:   'Tell us how we can help…',
      submit:                'Send message →',
      success:               "Thanks - your message has been sent. We'll get back to you as soon as we can.",
      err_validation:        'Fill in all required fields (message needs at least 10 characters).',
      err_rate_limited:      'Too many messages sent. Wait a few minutes and try again.',
      err_submit:            'Could not send the message. Please try again later.',
    },
    // Legacy keys kept so any older HTML still renders during the rollout.
    label_name:    'Name',
    label_email:   'Email address',
    label_subject: 'Subject',
    label_message: 'Message',
    btn_send:      'Send message',
  },
  inloggen: {
    title: 'Log in - Stroomkaart',
    aside: {
      eyebrow:    'Owner portal',
      title:      'Manage incoming requests for your power points.',
      lede:       "The Stroomkaart admin portal is where you manage requests to use your registered power points - available to every grid owner who wants to manage their grid connections.",
      feature_1:  'Review and approve or reject requests on your power points',
      feature_2:  'See the requester, location and requested period per request',
      feature_3:  'Track open, in-progress and completed requests',
      feature_4:  'Communicate with requesters from one central place',
      requester_box:  "<strong style=\"color: var(--sk-blue-300);\">Are you a requester?</strong> Requesters don't need an account. <a href=\"map.html\" style=\"color: var(--sk-blue-300); text-decoration: underline;\">Open the map</a> or <a href=\"request.html\" style=\"color: var(--sk-blue-300); text-decoration: underline;\">submit a request directly</a>. Status and updates arrive by email.",
      signup_intro:   "No access yet? <a href=\"#\" id=\"show-signup\">Register your power points</a> and we'll set up admin-portal accounts. Open to every grid owner - municipalities, grid operators, real-estate managers and businesses.",
    },
    form: {
      title:    'Sign in',
      sub:      'Access for owners - manage incoming requests.',
      email:    'Email',
      password: 'Password',
      remember: 'Remember me',
      forgot:   'Forgot password?',
      submit:   'Sign in →',
    },
    signup: {
      title:    'Register power points',
      sub:      "Fill in your details - we'll be in touch within two business days.",
      org:      'Organisation / Municipality',
      message:  'Message (optional)',
      submit:   'Submit →',
      success:  "Thanks - we'll be in touch within two business days.",
      err_duplicate: "We already have an open application with these details - we'll be in touch shortly.",
      err_submit:    'Could not send the application. Please try again later.',
    },
    back_to_login: '← Back to sign in',
    divider_or:    'or',
    forgot: {
      title:        'Reset password',
      sub:          "Enter your email and we'll send you a code to set a new password.",
      send_code:    'Send code →',
      code_label:   'Code from email',
      new_password: 'New password',
      confirm:      'Reset password →',
      code_sent:    "Check your inbox - we've sent you a code.",
      success:      'Password updated. You can sign in now.',
    },
    newpwd: {
      title:            'Set a new password',
      sub:              'Your account was created with a temporary password. Please choose your own now.',
      new_password:     'New password',
      confirm_password: 'Confirm password',
      submit:           'Save password →',
      mismatch:         "Passwords don't match.",
    },
    signedup_success: 'Account created. Sign in below.',
    errors: {
      not_admin:           'Your account is not an administrator. Sign in with an admin account.',
      invalid_credentials: 'Email or password is incorrect.',
      not_confirmed:       'Account is not confirmed yet. Check your email for the confirmation code.',
      reset_required:      "Your account requires a password reset. We've prefilled your email - request a code to continue.",
      weak_password:       'Password does not meet the requirements (min. 8 chars, uppercase, number, symbol).',
      rate_limited:        'Too many attempts. Please wait a few minutes and try again.',
      bad_code:            'Invalid code. Check your email and try again.',
      expired_code:        'Code expired. Request a new one.',
      network:             'Cannot reach the server. Check your internet connection.',
      empty_fields:        'Please fill in all required fields.',
      generic:             'Something went wrong. Please try again.',
    },
  },
};
